import { reactive } from 'vue'
import type { ToastType } from '../components/Toast/index.vue'

interface ToastOptions {
  type?: ToastType
  title: string
  message?: string
  duration?: number
  showCloseButton?: boolean
}

interface ToastState {
  isVisible: boolean
  type: ToastType
  title: string
  message?: string
  duration: number
  showCloseButton: boolean
}

// 全局Toast状态
const toastState = reactive<ToastState>({
  isVisible: false,
  type: 'success',
  title: '',
  message: '',
  duration: 3000,
  showCloseButton: true
})

export function useToast() {
  const showToast = (options: ToastOptions) => {
    toastState.isVisible = false // 先隐藏当前toast

    // 延迟一点时间再显示新的toast，确保动画效果
    setTimeout(() => {
      toastState.type = options.type || 'success'
      toastState.title = options.title
      toastState.message = options.message
      toastState.duration = options.duration ?? 3000
      toastState.showCloseButton = options.showCloseButton ?? true
      toastState.isVisible = true
    }, 50)
  }

  const showSuccess = (title: string, message?: string, duration?: number) => {
    showToast({
      type: 'success',
      title,
      message,
      duration
    })
  }

  const showError = (title: string, message?: string, duration?: number) => {
    showToast({
      type: 'error',
      title,
      message,
      duration: duration ?? 5000 // 错误提示默认显示时间长一些
    })
  }

  const showWarning = (title: string, message?: string, duration?: number) => {
    showToast({
      type: 'warning',
      title,
      message,
      duration
    })
  }

  const hideToast = () => {
    toastState.isVisible = false
  }

  return {
    toastState,
    showToast,
    showSuccess,
    showError,
    showWarning,
    hideToast
  }
}
